/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Track_Select_TitleInputs */



/**
* | output |
* | --- |
* | "Event Track" |
*
* @param {Event_Track_Select_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_track_select_title = /** @type {((inputs?: Event_Track_Select_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Track_Select_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Piste d'événements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Event Track")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tracciamento eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Трек событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pista del evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件轨道")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントトラック")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट ट्रैक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pista de Eventos")
	return /** @type {LocalizedString} */ ("Event Track")
});